import { render, staticRenderFns } from "./frmertesitesbeallitas.vue?vue&type=template&id=118c1a28&scoped=true&"
import script from "./frmertesitesbeallitas.vue?vue&type=script&lang=js&"
export * from "./frmertesitesbeallitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c1a28",
  null
  
)

export default component.exports